// React
import React from 'react';
import classsNames from 'classnames';
// Styles
import useStyles from './StoreScheduleTableRow.styles';
import Conditional from '../common/conditional/Conditional';

const StoreScheduleTableRow = ({ classes, subtitle, title, children }) => {
  const componentClasses = useStyles();
  return (
    <div className={classsNames(componentClasses.root, classes.root)}>
      <div className={componentClasses.header}>
        <div className={classsNames(componentClasses.title, classes.title)}>
          {title}
        </div>
        <Conditional if={subtitle}>
          <div
            className={classsNames(componentClasses.subtitle, classes.subtitle)}
          >
            {subtitle}
          </div>
        </Conditional>
      </div>
      <div className={componentClasses.body}>{children}</div>
    </div>
  );
};

StoreScheduleTableRow.defaultProps = {
  classes: {},
};

export default StoreScheduleTableRow;
